import { reviewDateISO, reviewLabelDE } from "@/lib/currentYear";
import { Link } from "@/lib/router-compat";

interface FreshnessNoteProps {
  className?: string;
  /** Optional prefix, e.g. "Konditionen geprüft" */
  label?: string;
  /** Show the link to the methodology page (default: true) */
  showMethodLink?: boolean;
}

/**
 * Small, dated line signalling that the page content was reviewed this month.
 * Card conditions and rankings are refreshed continuously from the provider feed.
 */
export const FreshnessNote = ({
  className = "",
  label = "Stand",
  showMethodLink = true,
}: FreshnessNoteProps) => (
  <p className={`text-sm text-muted-foreground ${className}`}>
    {label}: <time dateTime={reviewDateISO()}>{reviewLabelDE()}</time>
    {showMethodLink && (
      <>
        {" · "}
        <Link to="/methodik" className="underline underline-offset-4 hover:text-primary">
          So vergleichen wir
        </Link>
      </>
    )}
  </p>
);
